import { DOCUMENT } from '@angular/common';
import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BootstrapAppService } from '../lib/services/bootstrap-app.service';
import { BootstrapService } from '../lib/services/bootstrap.service';
import { ToastAppService } from '../lib/services/toast-app.service';
import { ToastService } from '../lib/services/toast.service';
import { appConfig } from './app.config';
import { DialogAppService } from './services/dialog-app.service';
import { DialogService } from './services/dialog.service';

const browserConfig: ApplicationConfig = {
  providers: [
    {
      provide: DialogService,
      useClass: DialogAppService,
    },
    {
      provide: ToastService,
      useClass: ToastAppService,
      deps: [DOCUMENT, TranslateService],
    },
    {
      provide: BootstrapService,
      useClass: BootstrapAppService,
    },
  ],
};

export const config = mergeApplicationConfig(appConfig, browserConfig);
